module.exports = __webpack_public_path__ + "static/img/10045B_1_R_20200922_fit.7d64e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10045B_1_R_20200922_fit.png
// module id = dRaj
// module chunks = 0